module.exports = __webpack_public_path__ + "img/icon-order-button.3fb0080e.svg";